export default "/images/vendor/@coreui/icons/svg/flag/cif-xk.svg?52cd940da7e20d34875656b578fcb54e";